"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTBidCancelBuilder = void 0;
const enums_1 = require("../enums");
const transactions_1 = require("../transactions");
const nft_exchange_builder_1 = require("./nft-exchange-builder");
class NFTBidCancelBuilder extends nft_exchange_builder_1.NFTExchangeTransactionBuilder {
    constructor() {
        super();
        this.data.type = enums_1.NFTTransactionTypes.NFTBidCancel;
        this.data.fee = transactions_1.NFTBidCancelTransaction.staticFee();
        this.data.asset = { nftBidCancel: {} };
    }
    NFTBidCancelAsset(nftBidCancel) {
        if (this.data.asset && this.data.asset.nftBidCancel) {
            this.data.asset.nftBidCancel = {
                ...nftBidCancel,
            };
        }
        return this;
    }
    instance() {
        return this;
    }
}
exports.NFTBidCancelBuilder = NFTBidCancelBuilder;
//# sourceMappingURL=nft-bid-cancel.js.map